import { render, staticRenderFns } from "./DentroFueraContent.vue?vue&type=template&id=30f951d4&scoped=true"
var script = {}
import style0 from "./DentroFueraContent.vue?vue&type=style&index=0&id=30f951d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f951d4",
  null
  
)

export default component.exports